import { SortObject } from '../../../../../shared/types';
import { ColumnFilterOptions } from '../../../../../shared/types/column-filter-options';
import { deleteUnusedFilterKeys, listTableState } from '../../../shared/components/asset-data-table/asset-data-table.helpers';
import * as assetActions from '../assets/asset.actions';
import { TableFilterObject } from '../types';
import * as matchAssetsActions from './match-assets.actions';

export interface State {
    selectedProjectId: number;
    sort: {
        [transactionId: number]: SortObject;
    };
    filter: {
        [transactionId: number]: TableFilterObject;
    };
    columnFiltersForFranchiseId: {
        [franchiseId: number]: ColumnFilterOptions;
    };
}

export const initialState: State = {
    selectedProjectId: null,
    sort: {},
    filter: {},
    columnFiltersForFranchiseId: {}
};

export function reducer(state = initialState, action: matchAssetsActions.Actions | assetActions.Actions): State {
    switch (action.type) {
        case matchAssetsActions.SELECT_PROJECT: {
            let newState = state;
            if (action.payload !== state.selectedProjectId) {
                newState = {
                    ...state,
                    selectedProjectId: action.payload
                };
            }

            return newState;
        }
        case matchAssetsActions.SORT_ASSETS_LIST: {
            const transactionId = action.payload.transactionId;
            const sort = action.payload.sort;
            const currentSort = state.sort[transactionId];

            if (currentSort && currentSort.field === sort.field && currentSort.order === sort.order) {
                return state;
            }

            return {
                ...state,
                sort: {
                    ...state.sort,
                    [transactionId]: {
                        ...sort
                    }
                }
            };
        }

        case matchAssetsActions.FILTER_ASSETS_LIST: {
            const transactionId = action.payload.transactionId;
            const updatedFilter: TableFilterObject = {
                ...state.filter[transactionId],
                ...action.payload.filter
            };

            return {
                ...state,
                filter: {
                    ...state.filter,
                    [transactionId]: deleteUnusedFilterKeys(updatedFilter)
                }
            };
        }

        case assetActions.LIST_BY_FRANCHISE_FILTERS_COMPLETE: {
            const columnFiltersForFranchiseId = { ...state.columnFiltersForFranchiseId };
            const franchiseId = action.payload.franchiseId;
            columnFiltersForFranchiseId[franchiseId] = action.payload.columnFilters;

            return {
                ...state,
                columnFiltersForFranchiseId
            };
        }

        case matchAssetsActions.LIST_TABLE_STATE_COMPLETE: {
            const transactionId = action.payload.transactionId;
            const { filter, sort } = listTableState(action.payload.tableState, state.filter, state.sort, transactionId);

            return {
                ...state,
                filter,
                sort
            };
        }

        default: {
            return state;
        }
    }
}

export const getMatchAssetsSort = (state: State) => state.sort;
export const getMatchAssetsFilter = (state: State) => state.filter;
export const getSelectedProjectId = (state: State) => state.selectedProjectId;
